<template>
    <div class="page magic-bg dark:text-white">
        <navigation :key="navigationKey"/>
        <div class="bookmark">
            <div class="bookmark-container">
                <div class="bookmark-modal" id="user_list_adjustments">
                    <div class="flex flex-row items-center justify-between mb-2">
                        <p class="bookmark-modal-title text-gradient mr-auto">Сортировка</p>
                        <button class="rounded-button" title="Очистить сортировку" @click="ClearParams">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 hover:animate-spin" viewBox="0 0 20 20" fill="currentColor">
                                <path fill-rule="evenodd" d="M4 2a1 1 0 011 1v2.101a7.002 7.002 0 0111.601 2.566 1 1 0 11-1.885.666A5.002 5.002 0 005.999 7H9a1 1 0 010 2H4a1 1 0 01-1-1V3a1 1 0 011-1zm.008 9.057a1 1 0 011.276.61A5.002 5.002 0 0014.001 13H11a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0v-2.101a7.002 7.002 0 01-11.601-2.566 1 1 0 01.61-1.276z" clip-rule="evenodd" />
                            </svg>
                        </button>
                    </div>
                    <div class="form-group ml-2 mt-2">
                        <label class="w-28">Поиск</label>
                        <input class="input sm:ml-2" type="text" v-model="search_param">
                    </div>
                    <div class="form-group ml-2 mt-2">
                        <label class="w-28">Роль</label>
                        <select class="input sm:ml-2" v-model="role_param">
                            <option value="">Все</option>
                            <option value="Listener">Слушатель</option>
                            <option value="Worker">Работник</option>
                            <option value="Student">Студент</option>
                        </select>
                    </div>
                    <div class="form-group ml-2 mt-2">
                        <label class="w-28">Пол</label>
                        <select class="input sm:ml-2" v-model="gender_param">
                            <option value="">Все</option>
                            <option value="Жен.">Жен.</option>
                            <option value="Муж.">Муж.</option>
                        </select>
                    </div>
                    <div class="form-group ml-2 mt-2">
                        <label class="w-28">ОВЗ</label>
                        <select class="input sm:ml-2" v-model="ovz_param">
                            <option value="">Все</option>
                            <option value="true">Имеется</option>
                            <option value="false">Не имеется</option>
                        </select>
                    </div>
                    <div class="form-group ml-2 mt-2">
                        <label class="w-28">Инвалидность</label>
                        <select class="input sm:ml-2" v-model="disability_param">
                            <option value="">Все</option>
                            <option value="true">Имеется</option>
                            <option value="false">Не имеется</option>
                        </select>
                    </div>
                    <p class="bookmark-modal-title text-gradient mr-auto">Инструменты</p>
                    <button class="mt-2 ml-2 mr-auto" @click="pageNumber = 0;_ProccessUsers()">Запросить данные заново</button>
                    <button class="mt-2 ml-2 mr-auto" @click="DownloadUserList">Выгрузить список пользователей</button>
                    <button class="mt-2 ml-2 mr-auto" @click="$root.ShowModal('#NewWorker')">Создать нового работника</button>
                    <button class="mt-2 ml-2 mr-auto" @click="$root.ShowModal('#NewListener')">Создать нового слушателя</button>
                    <button class="mt-2 ml-2 mr-auto" @click="$root.ShowModal('#NewStudent')">Создать нового студента</button>
                </div>
            </div>
            <div class="bookmark-navbar">
                <div class="bookmark-link" @click="$root.ToggleBookmark('#user_list_adjustments')">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                        <path d="M5 4a1 1 0 00-2 0v7.268a2 2 0 000 3.464V16a1 1 0 102 0v-1.268a2 2 0 000-3.464V4zM11 4a1 1 0 10-2 0v1.268a2 2 0 000 3.464V16a1 1 0 102 0V8.732a2 2 0 000-3.464V4zM16 3a1 1 0 011 1v7.268a2 2 0 010 3.464V16a1 1 0 11-2 0v-1.268a2 2 0 010-3.464V4a1 1 0 011-1z" />
                    </svg>
                </div>
            </div>
        </div>
        <div class="flex flex-row items-end justify-between mt-4 w-[90%] max-w-7xl mx-auto fade">
            <div class="flex flex-row items-center justify-center background rounded-t-lg ml-3 py-2 px-3 fade">
                <p>С</p>
                <p class="ml-2">{{pageNumber * elementNumber + 1}}</p>
                <p class="ml-2">по</p>
                <p class="ml-2">{{pageNumber * elementNumber + users.length}}</p>
                <p class="ml-2"><b class="text-gradient">Всего:</b> {{userCount}}</p>
            </div>
            <div class="flex flex-row items-center justify-center background rounded-t-lg mr-3 py-2 px-3 fade">
                <button @click="Back">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clip-rule="evenodd" />
                    </svg>
                </button>
                <p>{{pageNumber + 1}}</p>
                <p class="ml-2">из</p>
                <p class="ml-2">{{pagesCount}}</p>
                <button @click="Forward">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd" />
                    </svg>
                </button>
            </div>
        </div>
        <div class="card py-0 w-[90%] max-w-7xl mx-auto overflow-auto fade" style="max-height: calc(100vh - 10rem)">
            <table class="sys-table mb-2">
                <thead>
                    <th>№</th>
                    <th v-if="$root.HasRole($store.state.adminRole)">ID</th>
                    <th v-if="$root.HasRole($store.state.adminRole)">AsuID</th>
                    <th v-if="$root.HasRole($store.state.adminRole)">StudID</th>
                    <th>Логин</th>
                    <th>ФИО</th>
                    <th>Пол</th>
                    <th>Роль</th>
                    <th>Почты</th>
                    <th>Номера телефонов</th>
                    <th>ОВЗ</th>
                    <th>Инвалидность</th>
                    <th></th>
                    <th v-if="$root.HasRole($store.state.adminRole)"></th>
                    <th v-if="$root.HasRole($store.state.adminRole)"></th>
                </thead>
                <tbody>
                    <tr v-for="(user, index) in users" :key="index">
                        <th>{{pageNumber * elementNumber + index + 1}}</th>
                        <td class="text-center" v-if="$root.HasRole($store.state.adminRole)">{{user.ID}}</td>
                        <td class="text-center" v-if="$root.HasRole($store.state.adminRole)">{{user.AsuID == 0 ? '-' : user.AsuID}}</td>
                        <td class="text-center" v-if="$root.HasRole($store.state.adminRole)">{{user.Role === 'student' ? user.StudID : '-'}}</td>
                        <td>{{user.Login}}</td>
                        <td>{{user.FIO}}</td>
                        <td>{{user.Gender}}</td>
                        <td>{{user.Role === 'listener' ? 'Слушатель' : user.Role === 'worker' ? 'Работник' : user.Role === 'student' ? 'Студент' : 'данных нет'}}</td>
                        <td>{{user.Emails !== null ? user.Emails.join(",") : ''}}</td>
                        <td>{{user.Phones !== null ? user.Phones.join(",") : ''}}</td>
                        <td>{{user.OVZ !== null ? user.OVZ ? 'имеется' : 'не имеется' : 'данных нет'}}</td>
                        <td>{{user.Disability !== null ? user.Disability ? 'имеется' : 'не имеется' : 'данных нет'}}</td>
                        <th>
                            <button class="text-blue-600" @click="SeeUser(user.ID)">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                                </svg>
                            </button>
                        </th>
                        <th>
                            <button class="text-amber-600" @click="ShowChangeUserRole(user.ID)" v-if="!user.IsSystem">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                                    <path d="M8 5a1 1 0 100 2h5.586l-1.293 1.293a1 1 0 001.414 1.414l3-3a1 1 0 000-1.414l-3-3a1 1 0 10-1.414 1.414L13.586 5H8zM12 15a1 1 0 100-2H6.414l1.293-1.293a1 1 0 10-1.414-1.414l-3 3a1 1 0 000 1.414l3 3a1 1 0 001.414-1.414L6.414 15H12z" />
                                </svg>
                            </button>
                        </th>
                        <th v-if="$root.HasRole($store.state.adminRole)">
                            <button class="text-red-600" @click="DeleteUser(user.ID)" v-if="!user.IsSystem">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                                    <path fill-rule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z" clip-rule="evenodd" />
                                </svg>
                            </button>
                        </th>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

    <div class="modal dark:text-white" id="NewWorker" @click="$root.HideModal('#NewWorker')">
        <form class="modal-dialog" @submit="NewWorker" @click="(e)=>{e.stopPropagation()}">
            <div class="modal-dialog-header">
                <p class="modal-dialog-title">Новый работник</p>
                <button type="button" class="ml-auto" @click="$root.HideModal('#NewWorker')">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                    </svg>
                </button>
            </div>
            <div class="modal-dialog-body">
                <div class="form-group w-full my-2">
                    <label class="input-label">Фамилия <b class="text-red-600">*</b></label>
                    <input type="text" class="input sm:ml-auto" ref="worker_surname">
                </div>
                <div class="form-group w-full my-2">
                    <label class="input-label">Имя <b class="text-red-600">*</b></label>
                    <input type="text" class="input sm:ml-auto" ref="worker_name">
                </div>
                <div class="form-group w-full my-2">
                    <label class="input-label">Отчество</label>
                    <input type="text" class="input sm:ml-auto" ref="worker_lastname">
                </div>
                <div class="form-group w-full my-2">
                    <label class="input-label">Дата рождения <b class="text-red-600">*</b></label>
                    <input type="date" class="input sm:ml-auto" ref="worker_birthdate">
                </div>
                <div class="form-group w-full my-2">
                    <label class="input-label">Пол <b class="text-red-600">*</b></label>
                    <select class="input sm:ml-auto" ref="worker_gender">
                        <option value="">Не выбрано</option>
                        <option value="Муж.">Муж.</option>
                        <option value="Жен.">Жен.</option>
                    </select>
                </div>
                <div class="form-group w-full my-2">
                    <label class="input-label">Уровень образования <b class="text-red-600">*</b></label>
                    <select class="input sm:ml-auto" ref="worker_education_lvl">
                        <option value="">Не выбрано</option>
                        <option value="Среднее общее">Среднее общее</option>
                        <option value="Основное">Основное</option>
                        <option value="Неоконченное основное">Неоконченное основное</option>
                        <option value="Среднее профессиональное образование">Среднее профессиональное образование</option>
                        <option value="Неоконченное среднее профессиональное образование">Неоконченное среднее профессиональное образование</option>
                        <option value="Высшее">Высшее</option>
                        <option value="Неоконченное высшее">Неоконченное высшее</option>
                    </select>
                </div>
                <div class="form-group w-full my-2">
                    <label class="input-label">Занимаемая должность</label>
                    <input type="text" class="input sm:ml-auto" ref="worker_post">
                </div>
                <div class="form-group w-full my-2">
                    <label class="input-label">Дата назначения</label>          
                    <input type="date" class="input sm:ml-auto" ref="worker_post_date">
                </div>
                <div class="form-group w-full my-2">
                    <label class="input-label">Опыт работы</label>
                    <input type="number" class="input sm:ml-auto" ref="worker_work_exp">
                </div>
                <div class="form-group w-full my-2">
                    <label class="input-label">Опыт преподавательской работы</label>
                    <input type="number" class="input sm:ml-auto" ref="worker_education_exp">
                </div>
                <div class="form-group w-full my-2">
                    <label class="input-label">ОВЗ</label>
                    <input class="checkbox sm:ml-auto" type="checkbox" ref="worker_ovz">
                </div>
                <div class="form-group w-full my-2">
                    <label class="input-label">Инвалидность</label>
                    <input class="checkbox sm:ml-auto" type="checkbox" ref="worker_disability">
                </div>
                <div class="flex flex-col my-2">
                    <label class="input-label mr-auto">Почты</label>
                    <editable-data-list listID="ue" key="ue" />
                </div>
                <div class="flex flex-col my-2">
                    <label class="input-label mr-auto">Номера телефонов</label>
                    <editable-data-list listID="up" key="up"/>
                </div>
                <div class="flex flex-col my-2">
                    <label class="input-label mr-auto">Квалификации</label>
                    <editable-data-list listID="uq" key="uq"/>
                </div>
                <div class="flex flex-col my-2">
                    <label class="input-label mr-auto">Учёные степени</label>
                    <editable-data-list listID="ud" key="ud"/>
                </div>
                <div class="flex flex-col my-2">
                    <label class="input-label mr-auto">Законченные учебные заведения</label>
                    <editable-data-list listID="uest" key="uest"/>
                </div>
            </div>
            <div class="modal-dialog-footer">
                <button type="button" class="modal-dialog-footer-button" @click="$root.HideModal('#NewWorker')">Закрыть</button>
                <button type="submit" class="modal-dialog-footer-button" @click="$root.HideModal('#NewWorker')">Добавить</button>
            </div>
        </form>
    </div>

    <div class="modal dark:text-white" id="NewListener" @click="$root.HideModal('#NewListener')">
        <form class="modal-dialog" @submit="NewListener" @click="(e)=>{e.stopPropagation()}">
            <div class="modal-dialog-header">
                <p class="modal-dialog-title">Новый слушатель</p>
                <button type="button" class="ml-auto" @click="$root.HideModal('#NewListener')">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                    </svg>
                </button>
            </div>
            <div class="modal-dialog-body">
                <div class="form-group w-full my-2">
                    <label class="input-label">Фамилия <b class="text-red-600">*</b></label>
                    <input type="text" class="input sm:ml-auto" ref="listener_surname">
                </div>
                <div class="form-group w-full my-2">
                    <label class="input-label">Имя <b class="text-red-600">*</b></label>
                    <input type="text" class="input sm:ml-auto" ref="listener_name">
                </div>
                <div class="form-group w-full my-2">
                    <label class="input-label">Отчество</label>
                    <input type="text" class="input sm:ml-auto" ref="listener_lastname">
                </div>
                <div class="form-group w-full my-2">
                    <label class="input-label">Дата рождения <b class="text-red-600">*</b></label>
                    <input type="date" class="input sm:ml-auto" ref="listener_birthdate">
                </div>
                <div class="form-group w-full my-2">
                    <label class="input-label">Пол <b class="text-red-600">*</b></label>
                    <select class="input sm:ml-auto" ref="listener_gender">
                        <option value="">Не выбрано</option>
                        <option value="Муж.">Муж.</option>
                        <option value="Жен.">Жен.</option>
                    </select>
                </div>
                <div class="form-group w-full my-2">
                    <label class="input-label">Уровень образования <b class="text-red-600">*</b></label>
                    <select class="input sm:ml-auto" ref="listener_education_lvl">
                        <option value="">Не выбрано</option>
                        <option value="Среднее общее">Среднее общее</option>
                        <option value="Основное">Основное</option>
                        <option value="Неоконченное основное">Неоконченное основное</option>
                        <option value="Среднее профессиональное образование">Среднее профессиональное образование</option>
                        <option value="Неоконченное среднее профессиональное образование">Неоконченное среднее профессиональное образование</option>
                        <option value="Высшее">Высшее</option>
                        <option value="Неоконченное высшее">Неоконченное высшее</option>
                    </select>
                </div>
                <div class="form-group w-full my-2">
                    <label class="input-label">Занимаемая должность</label>
                    <input type="text" class="input sm:ml-auto" ref="listener_post">
                </div>
                <div class="form-group w-full my-2">
                    <label class="input-label">Дата назначения</label>          
                    <input type="date" class="input sm:ml-auto" ref="listener_post_date">
                </div>
                <div class="form-group w-full my-2">
                    <label class="input-label">Место обучения</label>
                    <input type="text" class="input sm:ml-auto" ref="listener_study_place">
                </div>
                <div class="form-group w-full my-2">
                    <label class="input-label">Место работы</label>
                    <input type="text" class="input sm:ml-auto" ref="listener_work_place">
                </div>
                <div class="form-group w-full my-2">
                    <label class="input-label">ОВЗ</label>
                    <input class="checkbox sm:ml-auto" type="checkbox" ref="listener_ovz">
                </div>
                <div class="form-group w-full my-2">
                    <label class="input-label">Инвалидность</label>
                    <input class="checkbox sm:ml-auto" type="checkbox" ref="listener_disability">
                </div>
                <div class="flex flex-col my-2">
                    <label class="input-label mr-auto">Почты</label>
                    <editable-data-list listID="ue" key="ue" />
                </div>
                <div class="flex flex-col my-2">
                    <label class="input-label mr-auto">Номера телефонов</label>
                    <editable-data-list listID="up" key="up"/>
                </div>
                <div class="flex flex-col my-2">
                    <label class="input-label mr-auto">Квалификации</label>
                    <editable-data-list listID="uq" key="uq"/>
                </div>
            </div>
            <div class="modal-dialog-footer">
                <button type="button" class="modal-dialog-footer-button" @click="$root.HideModal('#NewListener')">Закрыть</button>
                <button type="submit" class="modal-dialog-footer-button" @click="$root.HideModal('#NewListener')">Добавить</button>
            </div>
        </form>
    </div>

    <div class="modal dark:text-white" id="NewStudent" @click="$root.HideModal('#NewStudent')">
        <form class="modal-dialog" @submit="NewStudent" @click="(e)=>{e.stopPropagation()}">
            <div class="modal-dialog-header">
                <p class="modal-dialog-title">Новый студент</p>
                <button type="button" class="ml-auto" @click="$root.HideModal('#NewStudent')">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                    </svg>
                </button>
            </div>
            <div class="modal-dialog-body">
                <div class="form-group w-full my-2">
                    <label class="input-label">Фамилия <b class="text-red-600">*</b></label>
                    <input type="text" class="input sm:ml-auto" ref="student_surname">
                </div>
                <div class="form-group w-full my-2">
                    <label class="input-label">Имя <b class="text-red-600">*</b></label>
                    <input type="text" class="input sm:ml-auto" ref="student_name">
                </div>
                <div class="form-group w-full my-2">
                    <label class="input-label">Отчество</label>
                    <input type="text" class="input sm:ml-auto" ref="student_lastname">
                </div>
                <div class="form-group w-full my-2">
                    <label class="input-label">Дата рождения <b class="text-red-600">*</b></label>
                    <input type="date" class="input sm:ml-auto" ref="student_birthdate">
                </div>
                <div class="form-group w-full my-2">
                    <label class="input-label">Пол <b class="text-red-600">*</b></label>
                    <select class="input sm:ml-auto" ref="student_gender">
                        <option value="">Не выбрано</option>
                        <option value="Муж.">Муж.</option>
                        <option value="Жен.">Жен.</option>
                    </select>
                </div>
                <div class="form-group w-full my-2">
                    <label class="input-label">ОВЗ</label>
                    <input class="checkbox sm:ml-auto" type="checkbox" ref="student_ovz">
                </div>
                <div class="form-group w-full my-2">
                    <label class="input-label">Инвалидность</label>
                    <input class="checkbox sm:ml-auto" type="checkbox" ref="student_disability">
                </div>
                <div class="flex flex-col my-2">
                    <label class="input-label mr-auto">Почты</label>
                    <editable-data-list listID="se" key="se" />
                </div>
                <div class="flex flex-col my-2">
                    <label class="input-label mr-auto">Номера телефонов</label>
                    <editable-data-list listID="sp" key="sp"/>
                </div>
            </div>
            <div class="modal-dialog-footer">
                <button type="button" class="modal-dialog-footer-button" @click="$root.HideModal('#NewStudent')">Закрыть</button>
                <button type="submit" class="modal-dialog-footer-button" @click="$root.HideModal('#NewStudent')">Добавить</button>
            </div>
        </form>
    </div>

    <div class="modal dark:text-white" id="SeeUser" @click="$root.HideModal('#SeeUser')">
        <div class="modal-dialog max-w-5xl" @click="(e)=>{e.stopPropagation()}">
            <div class="modal-dialog-header">
                <p class="modal-dialog-title">Просмотр данных пользователя</p>
                <button type="button" class="ml-auto" @click="$root.HideModal('#SeeUser')">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                    </svg>
                </button>
            </div>
            <div class="modal-dialog-body">
                <div class="flex flex-col sm:flex-row sm:justify-between my-2" v-if="$root.HasRole($store.state.adminRole)">
                    <p class="subtitle">ID</p>
                    <p>{{$root.IsEmpty(currentUser.ID)}}</p>
                </div>
                <div class="flex flex-col sm:flex-row sm:justify-between my-2" v-if="$root.HasRole($store.state.adminRole)">
                    <p class="subtitle">AsuID</p>
                    <p>{{$root.IsEmpty(currentUser.AsuID)}}</p>
                </div>
                <div class="flex flex-col sm:flex-row sm:justify-between my-2" v-if="$root.HasRole($store.state.adminRole) && currentUser.Role == 'student'">
                    <p class="subtitle">StudID</p>
                    <p>{{$root.IsEmpty(currentUser.StudID)}}</p>
                </div>
                <div class="flex flex-col sm:flex-row sm:justify-between my-2">
                    <p class="subtitle">Логин</p>
                    <p>{{$root.IsEmpty(currentUser.Login)}}</p>
                </div>
                <div class="flex flex-col sm:flex-row sm:justify-between my-2">
                    <p class="subtitle">Фамилия</p>
                    <p>{{$root.IsEmpty(currentUser.Surname)}}</p>
                </div>
                <div class="flex flex-col sm:flex-row sm:justify-between my-2">
                    <p class="subtitle">Имя</p>
                    <p>{{$root.IsEmpty(currentUser.Name)}}</p>
                </div>
                <div class="flex flex-col sm:flex-row sm:justify-between my-2">
                    <p class="subtitle">Отчество</p>
                    <p>{{$root.IsEmpty(currentUser.Lastname)}}</p>
                </div>
                <div class="flex flex-col sm:flex-row sm:justify-between my-2">
                    <p class="subtitle">Дата прождения</p>
                    <p>{{$root.IsEmpty(currentUser.BirthDate)}}</p>
                </div>
                <div class="flex flex-col sm:flex-row sm:justify-between my-2">
                    <p class="subtitle">Пол</p>
                    <p>{{$root.IsEmpty(currentUser.Gender)}}</p>
                </div>
                <div class="flex flex-col sm:flex-row sm:justify-between my-2">
                    <p class="subtitle">Уровень образования</p>
                    <p>{{$root.IsEmpty(currentUser.EducationLvl)}}</p>
                </div>
                <div class="flex flex-col sm:flex-row sm:justify-between my-2" v-if="currentUser.Post !== undefined && currentUser.Post !== null">
                    <p class="subtitle">Занимаемая должность</p>
                    <p>{{$root.IsEmpty(currentUser.Post.Title)}} {{$root.IsEmpty(currentUser.Post.Date)}}</p>
                </div>
                <div class="flex flex-col sm:flex-row sm:justify-between my-2" v-if="currentUser.Role == 'listener'">
                    <p class="subtitle">Место обучения</p>
                    <p>{{$root.IsEmpty(currentUser.StudyPlace)}}</p>
                </div>
                <div class="flex flex-col sm:flex-row sm:justify-between my-2" v-if="currentUser.Role == 'listener'">
                    <p class="subtitle">Место работы</p>
                    <p>{{$root.IsEmpty(currentUser.WorkPlace)}}</p>
                </div>
                <div class="flex flex-col sm:flex-row sm:justify-between my-2" v-if="currentUser.Role == 'worker'">
                    <p class="subtitle">Опыт работы</p>
                    <p>{{$root.IsEmpty(currentUser.Exp)}}</p>
                </div>
                <div class="flex flex-col sm:flex-row sm:justify-between my-2" v-if="currentUser.Role == 'worker'">
                    <p class="subtitle">Опыт преподавательской работы</p>
                    <p>{{$root.IsEmpty(currentUser.EducationExp)}}</p>
                </div>
                <div class="flex flex-col sm:flex-row sm:justify-between my-2">
                    <p class="subtitle">ОВЗ</p>
                    <p>{{currentUser.OVZ !== null ? currentUser.OVZ ? "имеется" : "не имеется" : "Данных нет"}}</p>
                </div>
                <div class="flex flex-col sm:flex-row sm:justify-between my-2">
                    <p class="subtitle">Инвалидность</p>
                    <p>{{currentUser.Disability !== null ? currentUser.Disability ? "имеется" : "не имеется" : "Данных нет"}}</p>
                </div>
                <div class="flex flex-col my-2">
                    <p class="subtitle">Почты</p>
                    <data-list :data="currentUser.Emails" />
                </div>
                <div class="flex flex-col my-2">
                    <p class="subtitle">Номера телефонов</p>
                    <data-list :data="currentUser.Phones" />
                </div>
                <div class="flex flex-col my-2" v-if="currentUser.Qualifications !== undefined && currentUser.Qualifications !== null">
                    <p class="subtitle">Квалификации</p>
                    <data-list :data="currentUser.Qualifications" />
                </div>
                <div class="flex flex-col my-2" v-if="currentUser.Role == 'worker'">
                    <p class="subtitle">Учёные степени</p>
                    <data-list :data="currentUser.Degrees" />
                </div>
                <div class="flex flex-col my-2" v-if="currentUser.Role == 'worker'">
                    <p class="subtitle">Законченные учебные заведения</p>
                    <data-list :data="currentUser.Establishments" />
                </div>
                <div class="flex flex-col my-2">
                    <p class="subtitle">Пройденные программы</p>
                    <div class="list-container">
                        <div class="list-container-item" v-for="(program, index) in currentUser.Programs" :key="'program_' + index">
                            <p>{{program.Title}}</p>
                            <button class="text-blue-600 hover:animate-pulse" @click="currentProgram = index; $root.HideModal('#SeeUser'); $root.ShowModal('#SeeProgram')">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                                    <path d="M10 12a2 2 0 100-4 2 2 0 000 4z" />
                                    <path fill-rule="evenodd" d="M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z" clip-rule="evenodd" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-dialog-footer" v-if="!currentUser.IsSystem">
                <button type="button" class="modal-dialog-footer-button" @click="$root.HideModal('#SeeUser');$root.ShowModal('#ChangeUser')">Изменить</button>
            </div>
        </div>
    </div>

    <div class="modal dark:text-white" id="SeeProgram" @click="$root.HideModal('#SeeProgram');$root.ShowModal('#SeeUser')">
        <div class="modal-dialog max-w-5xl" @click="(e)=>{e.stopPropagation()}">
            <div class="modal-dialog-header">
                <p class="modal-dialog-title">Просмотр данных программы</p>
                <button type="button" class="ml-auto" @click="$root.HideModal('#SeeProgram');$root.ShowModal('#SeeUser')">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                    </svg>
                </button>
            </div>
            <div class="modal-dialog-body" v-if="currentProgram !== null">
                <div class="flex flex-col sm:flex-row sm:justify-between my-2">
                    <p class="subtitle">Тип</p>
                    <p>{{currentUser.Programs[currentProgram].Type}}</p>
                </div>
                <div class="flex flex-col sm:flex-row sm:justify-between my-2">
                    <p class="subtitle">Аббревиатура</p>
                    <p>{{currentUser.Programs[currentProgram].Abbreviation}}</p>
                </div>
                <div class="flex flex-col sm:flex-row sm:justify-between my-2">
                    <p class="subtitle">Название</p>
                    <p>{{currentUser.Programs[currentProgram].Title}}</p>
                </div>
                <div class="flex flex-col sm:flex-row sm:justify-between my-2">
                    <p class="subtitle">Кол-во часов</p>
                    <p>{{currentUser.Programs[currentProgram].HourNumber}}</p>
                </div>
                <div class="flex flex-col sm:flex-row sm:justify-between my-2">
                    <p class="subtitle">Тип образования</p>
                    <p>{{currentUser.Programs[currentProgram].EducationType}}</p>
                </div>
                <div class="flex flex-col sm:flex-row sm:justify-between my-2">
                    <p class="subtitle">Тип образовательной программы</p>
                    <p>{{currentUser.Programs[currentProgram].ProgramType}}</p>
                </div>
                <div class="flex flex-col sm:flex-row sm:justify-between my-2">
                    <p class="subtitle">Документ об образовании</p>
                    <p>{{currentUser.Programs[currentProgram].DocumentType}}</p>
                </div>
                <div class="flex flex-col sm:flex-row sm:justify-between my-2">
                    <p class="subtitle">Профессия</p>
                    <p>{{currentUser.Programs[currentProgram].Profession.Title.trim() !== "" ? `${currentUser.Programs[currentProgram].Profession.Title.trim()}[${currentUser.Programs[currentProgram].Profession.Code}]` : ''}}</p>
                </div>
                <div class="flex flex-col">
                    <div class="flex flex-row items-center">
                        <p class="subtitle">Файлы</p>
                        <button class="rounded-button ml-2" v-if="!currentUser.IsSystem" @click="LoadProgramFile">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                                <path fill-rule="evenodd" d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z" clip-rule="evenodd" />
                            </svg>
                        </button>
                    </div>
                    <div class="overflow-auto" style="max-height: 300px;">
                        <div class="list-container max-w-[250px]">
                            <div class="list-container-item" v-for="(file, index) in currentUser.Programs[currentProgram].Files" :key="'file_' + index">
                                <p>{{file}}</p>
                                <button class="text-blue-600 hover:animate-bounce ml-auto" @click="DownloadProgramFile(currentUser.ID, currentUser.Programs[currentProgram].ID, file)">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                                        <path fill-rule="evenodd" d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z" clip-rule="evenodd" />
                                    </svg>
                                </button>
                                <button v-if="!currentUser.IsSystem" class="text-danger hover:animate-pulse ml-2" @click="DeleteProgramFile(currentUser.ID, currentUser.Programs[currentProgram].ID, file)">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                                        <path fill-rule="evenodd" d="M5 10a1 1 0 011-1h8a1 1 0 110 2H6a1 1 0 01-1-1z" clip-rule="evenodd" />
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="modal dark:text-white" id="ChangeUser" @click="$root.HideModal('#ChangeUser');$root.ShowModal('#SeeUser')">
        <form class="modal-dialog" @submit="ChangeUser" @click="(e)=>{e.stopPropagation()}">
            <div class="modal-dialog-header">
                <p class="modal-dialog-title">Изменение данных пользователя</p>
                <button type="button" class="ml-auto" @click="$root.HideModal('#ChangeUser');$root.ShowModal('#SeeUser')">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                    </svg>
                </button>
            </div>
        <div class="modal-dialog-body">
            <div class="form-group w-full my-2" v-if="$root.HasRole($store.state.adminRole)">
                <label class="input-label">AsuID</label>
                <input type="number" class="input sm:ml-auto" min="0" :value="currentUser.AsuID" ref="user_asu_id">
            </div>
            <div class="form-group w-full my-2" v-if="$root.HasRole($store.state.adminRole) && currentUser.Role == 'student'">
                <label class="input-label">StudID</label>
                <input type="number" class="input sm:ml-auto" min="0" :value="currentUser.StudID" ref="user_stud_id">
            </div>
            <div class="form-group w-full my-2">
                <label class="input-label">Фамилия</label>
                <input type="text" class="input sm:ml-auto" :value="currentUser.Surname" ref="user_surname">
            </div>
            <div class="form-group w-full my-2">
                <label class="input-label">Имя</label>
                <input type="text" class="input sm:ml-auto" :value="currentUser.Name" ref="user_name">
            </div>
            <div class="form-group w-full my-2">
                <label class="input-label">Отчество</label>
                <input type="text" class="input sm:ml-auto" :value="currentUser.Lastname" ref="user_lastname">
            </div>
            <div class="form-group w-full my-2">
                <label class="input-label">Дата рождения</label>
                <input type="date" class="input sm:ml-auto" :value="$root.FormatInputDate(currentUser.BirthDate)" ref="user_birthdate">
            </div>
            <div class="form-group w-full my-2">
                <label class="input-label">Пол</label>
                <select class="input sm:ml-auto" :value="currentUser.Gender" ref="user_gender">
                    <option value="">Не выбрано</option>
                    <option value="Муж.">Муж.</option>
                    <option value="Жен.">Жен.</option>
                </select>
            </div>
            <div class="form-group w-full my-2" v-if="currentUser.EducationLvl !== undefined && currentUser.Qualifications !== null">
                <label class="input-label">Уровень образования</label>
                <select class="input sm:ml-auto" :value="currentUser.EducationLvl" ref="user_education_lvl">
                    <option value="">Не выбрано</option>
                    <option value="Среднее общее">Среднее общее</option>
                    <option value="Основное">Основное</option>
                    <option value="Неоконченное основное">Неоконченное основное</option>
                    <option value="Среднее профессиональное образование">Среднее профессиональное образование</option>
                    <option value="Неоконченное среднее профессиональное образование">Неоконченное среднее профессиональное образование</option>
                    <option value="Высшее">Высшее</option>
                    <option value="Неоконченное высшее">Неоконченное высшее</option>
                </select>
            </div>
            <div class="form-group w-full my-2" v-if="currentUser.Post !== undefined && currentUser.Post !== null">
                <label class="input-label">Занимаемая должность</label>
                <input type="text" class="input sm:ml-auto" :value="currentUser.Post.Title" ref="user_post">
            </div>
            <div class="form-group w-full my-2" v-if="currentUser.Post !== undefined && currentUser.Post !== null">
                <label class="input-label">Дата назначения</label>          
                <input type="date" class="input sm:ml-auto" :value="$root.FormatInputDate(currentUser.Post.Date)" ref="user_post_date">
            </div>
            <div class="form-group w-full my-2" v-if="currentUser.Role == 'listener'">
                <label class="input-label">Место обучения</label>
                <input type="text" class="input sm:ml-auto" :value="currentUser.StudyPlace" ref="user_study_place">
            </div>
            <div class="form-group w-full my-2" v-if="currentUser.Role == 'listener'">
                <label class="input-label">Место работы</label>
                <input type="text" class="input sm:ml-auto" :value="currentUser.WorkPlace" ref="user_work_place">
            </div>
            <div class="form-group w-full my-2" v-if="currentUser.Role == 'worker'">
                <label class="input-label">Опыт работы</label>
                <input type="number" class="input sm:ml-auto" :value="currentUser.Exp" ref="user_work_exp">
            </div>
            <div class="form-group w-full my-2" v-if="currentUser.Role == 'worker'">
                <label class="input-label">Опыт преподавательской работы</label>
                <input type="number" class="input sm:ml-auto" :value="currentUser.EducationExp" ref="user_education_exp">
            </div>
            <div class="form-group w-full my-2">
                <label class="input-label">ОВЗ</label>
                <input class="checkbox sm:ml-auto" type="checkbox" :checked="currentUser.OVZ" ref="user_ovz">
            </div>
            <div class="form-group w-full my-2">
                <label class="input-label">Инвалидность</label>
                <input class="checkbox sm:ml-auto" type="checkbox" :checked="currentUser.Disability" ref="user_disability">
            </div>
            <div class="flex flex-col my-2">
                <label class="input-label mr-auto">Почты</label>
                <editable-data-list :data="currentUser.Emails.slice()" listID="ue" key="ue" ref="ue"/>
            </div>
            <div class="flex flex-col my-2">
                <label class="input-label mr-auto">Номера телефонов</label>
                <editable-data-list :data="currentUser.Phones.slice()" listID="up" key="up" ref="up"/>
            </div>
            <div class="flex flex-col my-2" v-if="currentUser.Qualifications !== undefined && currentUser.Qualifications !== null">
                <label class="input-label mr-auto">Квалификации</label>
                <editable-data-list :data="currentUser.Qualifications.slice()" listID="uq" key="uq" ref="uq"/>
            </div>
            <div class="flex flex-col my-2" v-if="currentUser.Role == 'worker'">
                <label class="input-label mr-auto">Учёные степени</label>
                <editable-data-list :data="currentUser.Degrees.slice()" listID="ud" key="ud" ref="ud"/>
            </div>
            <div class="flex flex-col my-2" v-if="currentUser.Role == 'worker'">
                <label class="input-label mr-auto">Законченные учебные заведения</label>
                <editable-data-list :data="currentUser.Establishments.slice()" listID="uest" key="uest" ref="uest"/>
            </div>
            <div class="flex flex-col my-2" v-if="$root.HasRole($store.state.adminRole)">
                <label class="input-label mr-auto">Роли</label>
                <div class="flex flex-col" ref="user_roles">
                    <div class="flex flex-row items-center justify-start my-2" v-for="(role, index) in roles" :key="index">
                        <input class="checkbox" type="checkbox" :value="role.ID" :checked="currentUser.Roles.includes(role.ID)" name="role">
                        <label class="ml-2">{{role.Title}}</label>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-dialog-footer">
            <button type="button" class="modal-dialog-footer-button" @click="$root.HideModal('#ChangeUser');$root.ShowModal('#SeeUser')">Закрыть</button>
            <button type="submit" class="modal-dialog-footer-button" @click="$root.HideModal('#ChangeUser')">Изменить</button>
        </div>
        </form>
    </div>

    <div class="modal dark:text-white" id="ChangeUserRole" @click="$root.HideModal('#ChangeUserRole')">
        <div class="modal-dialog" @click="(e)=>{e.stopPropagation()}">
            <div class="modal-dialog-footer flex-col">
                <button class="modal-dialog-footer-button" @click="$root.HideModal('#ChangeUserRole')">Закрыть</button>
                <button class="modal-dialog-footer-button" @click="$root.HideModal('#ChangeUserRole');ChangeUserRole(currentUser.ID, 'worker')" v-if="currentUser.Role == 'listener' || currentUser.Role == 'student'">Перевести в работника</button>
                <button class="modal-dialog-footer-button" @click="$root.HideModal('#ChangeUserRole');ChangeUserRole(currentUser.ID, 'listener')" v-if="currentUser.Role == 'worker' || currentUser.Role == 'student'">Перевести в слушателя</button>
                <button class="modal-dialog-footer-button" @click="$root.HideModal('#ChangeUserRole');ChangeUserRole(currentUser.ID, 'student')" v-if="currentUser.Role == 'listener' || currentUser.Role == 'worker'">Перевести в студента</button>
            </div>
        </div>
    </div>
</template>

<script>
import Navigation from '@/components/Navigation'
import DataList from '@/components/DataList'
import EditableDataList from '@/components/EditableDataList'

export default {
    components: {
        Navigation,
        DataList,
        EditableDataList
    },
    data() {
        return {
            roles: [],
            search_param: "",
            gender_param: "",
            role_param: "",
            ovz_param: "",
            disability_param: "",
            elementNumber: 25,
            pageNumber: 0,
            userCount: 0,
            pagesCount: 0,
            users: [],
            programs: {},
            currentUser: {
                IsSystem: false,
                Roles: [],
                Post: {},
                Programs: [],
                ID: null,
                AsuID: null,
                StudID: null,
                Login: null,
                Role: null,
                Name: null,
                Surname: null,
                Lastname: null,
                BirthDate: null,
                Gender: null,
                Emails: [],
                Phones: [],
                EducationLvl: null,
                Qualifications: [],
                Degrees: [],
                Establishments: [],
                WorkPlace: null,
                StudyPlace: null,
                Exp: null,
                EducationExp: null,
                OVZ: null,
                Disability: null,
            },
            currentProgram: null,
            navigationKey: "nav",
            title: "Список пользователей"
        }
    },
    methods: {
        SetTitle() {
            document.title = `Samgk DPO - ${this.title}`
        },
        Forward() {
            this.pageNumber = this.pageNumber >= this.pagesCount - 1 ? 0 : this.pageNumber + 1
            this._ProccessUsers()
        },
        Back() {
            this.pageNumber = this.pageNumber <= 0 ? this.pagesCount - 1 : this.pageNumber - 1
            this._ProccessUsers()
        },
        ClearParams() {
            this.search_param = ""
            this.gender_param = ""
            this.role_param = ""
            this.ovz_param = ""
            this.disability_param = ""
        },
        async _ProccessRoles() {
            let res = await fetch(this.$store.state.adminApiAddr + "/v1.0/system/roles/all", {
                method: "GET",
                headers: {
                    'Authorization': `Bearer ${this.$root.GetToken()}`,
                },
            }).then(response => {return response.json()})
            .catch(error => {
                this.$root.Fatal()
            })

            let roles = []

            for (var i in res["data"]["roles"]) {
                let role = res["data"]["roles"][i]
                roles.push({ ID: role["id"], Title: role["title"] })
            }

            this.roles = roles
        },
        async _ProccessUsers() {
            this.$root.StartLoading()

            var res = await fetch(this.$store.state.apiAddr + `/v1.0/users/list?limit=${this.elementNumber}&skip=${this.pageNumber * this.elementNumber}&search=${this.search_param}&gender=${this.gender_param}&role=${this.role_param}&ovz=${this.ovz_param}&disability=${this.disability_param}&alphabetical=true&is_show_system=${this.$root.HasRole(this.$store.state.adminRole)}`, {
                method: "GET",
                headers: {
                    'Authorization': `Bearer ${this.$root.GetToken()}`,
                },
            }).then(response => {return response.json()})
            .catch(error => {
                this.$root.Fatal()
            })

            if (this.$root.HandleFetchError(res)) return

            this.userCount = res.data.collections

            this.pagesCount = Math.ceil(this.userCount / this.elementNumber)

            let isAdmin = this.$root.HasRole(this.$store.state.adminRole)

            let users = []

            for (var i in res.data.users) {
                var user = res.data.users[i]

                var listener = user.listener

                var worker = user.worker

                var student = user.student

                var role = user["roles"].includes(this.$store.state.employeeRole) ? "worker" : user["roles"].includes(this.$store.state.studentRole) ? "student" : user["roles"].includes(this.$store.state.listenerRole) ? "listener" : null
                
                users.push({
                    IsSystem: user.is_system,
                    ID: user.id,
                    AsuID: isAdmin ? user.asu_id : undefined,
                    StudID: isAdmin ? user.asu_stud_id : undefined,
                    Login: user.login,
                    Role: role,
                    FIO: role === "listener" ? `${listener.surname} ${listener.name} ${listener.middle_name}` : role === "worker" ? `${worker.surname} ${worker.name} ${worker.middle_name}` : role === "student" ? `${student.surname} ${student.name} ${student.middle_name}` : null,
                    Gender: role === "listener" ? listener.gender : role === "worker" ? worker.gender : role === "student" ? student.gender : null,
                    OVZ: role === "listener" ? listener.ovz : role === "worker" ? worker.ovz : role === "student" ? student.ovz : null,
                    Disability: role === "listener" ? listener.disability : role === "worker" ? worker.disability : role === "student" ? student.disability : null,
                    Emails: role === "listener" ? listener.emails || [] : role === "worker" ? worker.emails || [] : role === "student" ? student.emails || [] : null,
                    Phones: role === "listener" ? listener.number_phones || [] : role === "worker" ? worker.number_phones || [] : role === "student" ? student.number_phones || [] : null
                })
                
            }

            this.users = users

            this.$root.EndLoading()
        },
        NewWorker(e) {
            e.preventDefault()

            let form = e.target

            let surname = this.$refs.worker_surname.value
            let name = this.$refs.worker_name.value
            let lastname = this.$refs.worker_lastname.value
            let birthdate = this.$refs.worker_birthdate.value + "T00:00:00Z"
            let gender = this.$refs.worker_gender.value
            let education_lvl = this.$refs.worker_education_lvl.value
            let post = this.$refs.worker_post.value
            let post_date = this.$refs.worker_post_date.value + "T00:00:00Z"
            let ovz = this.$refs.worker_ovz.worker_checked
            let disability = this.$refs.worker_disability.checked

            birthdate = birthdate == "T00:00:00Z" ? undefined : birthdate
            post_date = post_date == "T00:00:00Z" ? undefined : post_date

            let emails_inputs = form.querySelector("div#ue").querySelectorAll(".list-container-item")
            let phones_inputs = form.querySelector("div#up").querySelectorAll(".list-container-item")
            let qualifications_inputs = form.querySelector("div#uq").querySelectorAll(".list-container-item")

            birthdate = birthdate === "T00:00:00Z" ? "" : birthdate
            post_date = post_date === "T00:00:00Z" ? "" : post_date

            let emails = []
            for (var index = 0; index < emails_inputs.length; index++) {
                var input_container = emails_inputs[index]
                var input = input_container.querySelector("input.list-container-input")
                emails.push(input.value)
            }

            let phones = []
            for (var index = 0; index < phones_inputs.length; index++) {
                var input_container = phones_inputs[index]
                var input = input_container.querySelector("input.list-container-input")
                phones.push(input.value)
            }

            let qualifications = []
            for (var index = 0; index < qualifications_inputs.length; index++) {
                var input_container = qualifications_inputs[index]
                var input = input_container.querySelector("input.list-container-input")
                qualifications.push(input.value)
            }

            let work_exp = Number(this.$refs.worker_work_exp.value)
            let education_exp = Number(this.$refs.worker_education_exp.value)

            let degrees_inputs = form.querySelector("div#ud").querySelectorAll(".list-container-item")
            let establishments_inputs = form.querySelector("div#uest").querySelectorAll(".list-container-item")

            let degrees = []
            for (var index = 0; index < degrees_inputs.length; index++) {
                var input_container = degrees_inputs[index]
                var input = input_container.querySelector("input.list-container-input").value.split(" ")

                var date = this.$root.FormatInputDate(input.pop())

                degrees.push({
                    "title": input.join(),
                    "date_of_assignment": date + "T00:00:00Z"
                })
            }

            let establishments = []
            for (var index = 0; index < establishments_inputs.length; index++) {
                var input_container = establishment_inputs[index]
                var input = input_container.querySelector("input.list-container-input")
                establishments.push(input.value)
            }

            fetch(this.$store.state.apiAddr + "/v1.0/users/worker", {
                method: "POST",
                headers: {
                    'Authorization': `Bearer ${this.$root.GetToken()}`,
                    'Content-Type': 'text/json;charset=utf-8'
                },
                body: JSON.stringify({
                    name: name,
                    surname: surname,
                    middle_name: lastname,
                    date_of_birth: birthdate,
                    gender: gender,
                    level_of_education: education_lvl,
                    post: {
                        title: post,
                        date_of_taking_office: post_date
                    },
                    general_experience: work_exp,
                    experience_of_teaching_work: education_exp,
                    ovz: ovz,
                    disability: disability,
                    emails: emails,
                    number_phones: phones,
                    qualifications: qualifications,
                    academic_degrees: degrees,
                    establishments: establishments
                })
            })
            .then(response => response.json())
            .then(res => {
                if (this.$root.HandleFetchError(res)) return
                this.$root.ShowToast("Работник успешно добавлен", "success")
                this._ProccessUsers()
            })
            .catch(error => {
                this.$root.Fatal()
            })
        },
        NewListener(e) {
            e.preventDefault()

            let form = e.target

            let surname = this.$refs.listener_surname.value
            let name = this.$refs.listener_name.value
            let lastname = this.$refs.listener_lastname.value
            let birthdate = this.$refs.listener_birthdate.value + "T00:00:00Z"
            let gender = this.$refs.listener_gender.value
            let education_lvl = this.$refs.listener_education_lvl.value
            let post = this.$refs.listener_post.value
            let post_date = this.$refs.listener_post_date.value + "T00:00:00Z"
            let ovz = this.$refs.listener_ovz.checked
            let disability = this.$refs.listener_disability.checked

            birthdate = birthdate == "T00:00:00Z" ? undefined : birthdate
            post_date = post_date == "T00:00:00Z" ? undefined : post_date

            let emails_inputs = form.querySelector("div#ue").querySelectorAll(".list-container-item")
            let phones_inputs = form.querySelector("div#up").querySelectorAll(".list-container-item")
            let qualifications_inputs = form.querySelector("div#uq").querySelectorAll(".list-container-item")

            birthdate = birthdate === "T00:00:00Z" ? "" : birthdate
            post_date = post_date === "T00:00:00Z" ? "" : post_date

            let emails = []
            for (var index = 0; index < emails_inputs.length; index++) {
                var input_container = emails_inputs[index]
                var input = input_container.querySelector("input.list-container-input")
                emails.push(input.value)
            }

            let phones = []
            for (var index = 0; index < phones_inputs.length; index++) {
                var input_container = phones_inputs[index]
                var input = input_container.querySelector("input.list-container-input")
                phones.push(input.value)
            }

            let qualifications = []
            for (var index = 0; index < qualifications_inputs.length; index++) {
                var input_container = qualifications_inputs[index]
                var input = input_container.querySelector("input.list-container-input")
                qualifications.push(input.value)
            }

            let study_place = this.$refs.listener_study_place.value
            let work_place = this.$refs.listener_work_place.value

            fetch(this.$store.state.apiAddr + "/v1.0/users/listener", {
                method: "POST",
                headers: {
                    'Authorization': `Bearer ${this.$root.GetToken()}`,
                    'Content-Type': 'text/json;charset=utf-8'
                },
                body: JSON.stringify({
                    name: name,
                    surname: surname,
                    middle_name: lastname,
                    date_of_birth: birthdate,
                    gender: gender,
                    level_of_education: education_lvl,
                    post: {
                        title: post,
                        date_of_taking_office: post_date
                    },
                    place_of_work: work_place,
                    place_of_study: study_place,
                    ovz: ovz,
                    disability: disability,
                    emails: emails,
                    number_phones: phones,
                    qualifications: qualifications
                })
            })
            .then(response => response.json())
            .then(res => {
                if (this.$root.HandleFetchError(res)) return
                this.$root.ShowToast("Слушатель успешно добавлен", "success")
                this._ProccessUsers()
            })
            .catch(error => {
                this.$root.Fatal()
            })
        },
        NewStudent(e) {
            e.preventDefault()

            let form = e.target

            let surname = this.$refs.student_surname.value
            let name = this.$refs.student_name.value
            let lastname = this.$refs.student_lastname.value
            let birthdate = this.$refs.student_birthdate.value + "T00:00:00Z"
            let gender = this.$refs.student_gender.value
            let ovz = this.$refs.student_ovz.checked
            let disability = this.$refs.student_disability.checked

            birthdate = birthdate == "T00:00:00Z" ? undefined : birthdate

            let emails_inputs = form.querySelector("div#se").querySelectorAll(".list-container-item")
            let phones_inputs = form.querySelector("div#sp").querySelectorAll(".list-container-item")

            birthdate = birthdate === "T00:00:00Z" ? "" : birthdate

            let emails = []
            for (var index = 0; index < emails_inputs.length; index++) {
                var input_container = emails_inputs[index]
                var input = input_container.querySelector("input.list-container-input")
                emails.push(input.value)
            }

            let phones = []
            for (var index = 0; index < phones_inputs.length; index++) {
                var input_container = phones_inputs[index]
                var input = input_container.querySelector("input.list-container-input")
                phones.push(input.value)
            }

            fetch(this.$store.state.apiAddr + "/v1.0/users/student", {
                method: "POST",
                headers: {
                    'Authorization': `Bearer ${this.$root.GetToken()}`,
                    'Content-Type': 'text/json;charset=utf-8'
                },
                body: JSON.stringify({
                    name: name,
                    surname: surname,
                    middle_name: lastname,
                    date_of_birth: birthdate,
                    gender: gender,
                    ovz: ovz,
                    disability: disability,
                    emails: emails,
                    number_phones: phones,
                })
            })
            .then(response => response.json())
            .then(res => {
                if (this.$root.HandleFetchError(res)) return
                this.$root.ShowToast("Студент успешно добавлен", "success")
                this._ProccessUsers()
            })
            .catch(error => {
                this.$root.Fatal()
            })
        },
        async SeeUser(id) {
            var res = await fetch(this.$store.state.apiAddr + `/v1.0/users/by_id/${id}`, {
                method: "GET",
                headers: {
                    'Authorization': `Bearer ${this.$root.GetToken()}`,
                },
            }).then(response => { return response.json() })
            .catch(error => {
                this.$root.Fatal()
            })

            if (this.$root.HandleFetchError(res)) return

            let isAdmin = this.$root.HasRole(this.$store.state.adminRole)

            if (res["error"] === undefined) {
                let user = res["data"]["user"]
                let employee = user["worker"]
                let listener = user["listener"]
                let student = user["student"]

                let isEmployee = user["roles"].includes(this.$store.state.employeeRole)
                let isStudent = user["roles"].includes(this.$store.state.studentRole)
                let isListenter = user["roles"].includes(this.$store.state.listenerRole)

                this.currentUser.IsSystem = user["is_system"]
                this.currentUser.ID = user["id"]
                this.currentUser.AsuID = isAdmin ? user["asu_id"] : null
                this.currentUser.StudID = isAdmin ? user["asu_stud_id"] : null
                this.currentUser.Login = user["login"]
                this.currentUser.Roles = user["roles"]
                this.currentUser.Role = isEmployee ? "worker" : isStudent ? "student" : isListenter ? "listener" : null

                this.currentUser.Name = isEmployee ? employee["name"] : isStudent ? student["name"] : isListenter ? listener["name"] : null
                this.currentUser.Surname = isEmployee ? employee["surname"] : isStudent ? student["surname"] : isListenter ? listener["surname"] : null
                this.currentUser.Lastname = isEmployee ? employee["middle_name"] : isStudent ? student["middle_name"] : isListenter ? listener["middle_name"] : null
                this.currentUser.BirthDate = isEmployee ? this.$root.FormatDate(employee["date_of_birth"]) : isStudent ? this.$root.FormatDate(student["date_of_birth"]) : isListenter ? this.$root.FormatDate(listener["date_of_birth"]) : null
                this.currentUser.Gender = isEmployee ? employee["gender"] : isStudent ? student["gender"] : isListenter ? listener["gender"] : null
                this.currentUser.Emails = isEmployee ? employee["emails"] || [] : isStudent ? student["emails"] || [] : isListenter ? listener["emails"] || [] : null
                this.currentUser.Phones = isEmployee ? employee["number_phones"] || [] : isStudent ? student["number_phones"] || [] : isListenter ? listener["number_phones"] || [] : null
                this.currentUser.OVZ = isEmployee ? employee["ovz"] : isStudent ? student["ovz"] : isListenter ? listener["ovz"] : null
                this.currentUser.EducationLvl = isEmployee ? employee["level_of_education"] : isListenter ? listener["level_of_education"] : null
                this.currentUser.Disability = isEmployee ? employee["disability"] : isStudent ? student["disability"] : isListenter ? listener["disability"] : null
                this.currentUser.Qualifications = isEmployee ? employee["qualifications"] : isListenter ? listener["qualifications"] : null

                this.currentUser.Post = isEmployee
                ? { Title: `${employee["post"]["title"]}`, Date: `${this.$root.FormatDate(employee["post"]["date_of_taking_office"])}`}
                : isListenter 
                ? { Title: `${listener["post"]["title"]}`, Date: `${this.$root.FormatDate(listener["post"]["date_of_taking_office"])}`}
                : null

                let programs = []

                if (this.currentUser.Role == "worker") {
                    
                    let ad = []
                    for (var i in employee["academic_degrees"]) {
                        ad.push(`${employee["academic_degrees"][i]["title"]} ${this.$root.FormatDate(employee["academic_degrees"][i]["date_of_assignment"])}`)
                    }
                    this.currentUser.Degrees = ad
                    this.currentUser.Exp = employee["general_experience"]
                    this.currentUser.EducationExp = employee["experience_of_teaching_work"]
                    this.currentUser.Establishments = employee["completed_educational_institutions"]
                    if (employee["programs"] != null) {

                        for (var i in employee["programs"]["major"]) {
                            var program = await fetch(this.$store.state.aeApiAddr +`/v1.0/programs/by_id/${employee["programs"]["additional"][i]}`, {
                                method: "GET",
                                headers: {
                                    'Authorization': `Bearer ${this.$root.GetToken()}`,
                                },
                            }).then(response =>{ return response.json() })
                            .catch(error => {
                                this.$root.Fatal()
                            })

                            program = program["data"]["program"]

                            programs.push({
                                Type: "Основная",
                                ID: program["id"],
                                Abbreviation: program["abbreviation"],
                                Title: program["title"],
                                HourNumber: program["number_of_hours"],
                                Location: program["location"],
                                DocumentType: program["type_document"],
                                EducationType: program["type_of_education"],
                                ProgramType: program["type_of_educational_program"],
                                FinancingType: program["type_of_financing"],
                                Price: program["price"],
                                Profession: {
                                    Title: program["profession"]["title"],
                                    Code: program["profession"]["code"]
                                },
                                Files: employee["programs"]["files"][program["id"]]
                            })
                        }

                        for (var i in employee["programs"]["additional"]) {
                            var program = await fetch(this.$store.state.aeApiAddr +`/v1.0/programs/by_id/${employee["programs"]["additional"][i]}`, {
                                method: "GET",
                                headers: {
                                    'Authorization': `Bearer ${this.$root.GetToken()}`,
                                },
                            }).then(response =>{ return response.json() })
                            .catch(error => {
                                this.$root.Fatal()
                            })

                            program = program["data"]["program"]

                            programs.push({
                                Type: "Дополнительная",
                                ID: program["id"],
                                Abbreviation: program["abbreviation"],
                                Title: program["title"],
                                HourNumber: program["number_of_hours"],
                                Location: program["location"],
                                DocumentType: program["type_document"],
                                EducationType: program["type_of_education"],
                                ProgramType: program["type_of_educational_program"],
                                FinancingType: program["type_of_financing"],
                                Price: program["price"],
                                Profession: {
                                    Title: program["profession"]["title"],
                                    Code: program["profession"]["code"]
                                },
                                Files: employee["programs"]["files"][program["id"]]
                            })
                        }
                    }
                }

                if (this.currentUser.Role == "listener") {
                    this.currentUser.WorkPlace = listener["place_of_work"]
                    this.currentUser.StudyPlace = listener["place_of_study"]

                    if (listener["programs"] != null) {

                        for (var i in listener["programs"]["major"]) {
                            var program = await fetch(this.$store.state.aeApiAddr +`/v1.0/programs/by_id/${listener["programs"]["additional"][i]}`, {
                                method: "GET",
                                headers: {
                                    'Authorization': `Bearer ${this.$root.GetToken()}`,
                                },
                            }).then(response =>{ return response.json() })
                            .catch(error => {
                                this.$root.Fatal()
                            })

                            program = program["data"]["program"]

                            programs.push({
                                Type: "Основная",
                                ID: program["id"],
                                Abbreviation: program["abbreviation"],
                                Title: program["title"],
                                HourNumber: program["number_of_hours"],
                                Location: program["location"],
                                DocumentType: program["type_document"],
                                EducationType: program["type_of_education"],
                                ProgramType: program["type_of_educational_program"],
                                FinancingType: program["type_of_financing"],
                                Price: program["price"],
                                Profession: {
                                    Title: program["profession"]["title"],
                                    Code: program["profession"]["code"]
                                },
                                Files: listener["programs"]["files"][program["id"]]
                            })
                        }

                        for (var i in listener["programs"]["additional"]) {
                            var program = await fetch(this.$store.state.aeApiAddr +`/v1.0/programs/by_id/${listener["programs"]["additional"][i]}`, {
                                method: "GET",
                                headers: {
                                    'Authorization': `Bearer ${this.$root.GetToken()}`,
                                },
                            }).then(response =>{ return response.json() })
                            .catch(error => {
                                this.$root.Fatal()
                            })

                            program = program["data"]["program"]

                            programs.push({
                                Type: "Дополнительная",
                                ID: program["id"],
                                Abbreviation: program["abbreviation"],
                                Title: program["title"],
                                HourNumber: program["number_of_hours"],
                                Location: program["location"],
                                DocumentType: program["type_document"],
                                EducationType: program["type_of_education"],
                                ProgramType: program["type_of_educational_program"],
                                FinancingType: program["type_of_financing"],
                                Price: program["price"],
                                Profession: {
                                    Title: program["profession"]["title"],
                                    Code: program["profession"]["code"]
                                },
                                Files: listener["programs"]["files"][program["id"]]
                            })
                        }

                    }
                }

                this.currentUser.Programs = programs

                this.$root.ShowModal("#SeeUser")
            }
        },
        async ShowChangeUserRole(id) {
            var res = await fetch(this.$store.state.apiAddr + `/v1.0/users/by_id/${id}`, {
                method: "GET",
                headers: {
                    'Authorization': `Bearer ${this.$root.GetToken()}`,
                },
            }).then(response => { return response.json() })
            .catch(error => {
                this.$root.Fatal()
            })

            if (this.$root.HandleFetchError(res)) return

            if (res["error"] === undefined) {
                let user = res["data"]["user"]
                
                this.currentUser.ID = user["id"]

                this.currentUser.Role = user["roles"].includes(this.$store.state.employeeRole) 
                                        ? "worker" 
                                        : user["roles"].includes(this.$store.state.studentRole) 
                                        ? "student"
                                        : user["roles"].includes(this.$store.state.listenerRole)
                                        ? "listener"
                                        : null
            }

            this.$root.ShowModal("#ChangeUserRole")
        },
        ChangeUserRole(id, role) {
            if (!["listener", "student", "worker"].includes(role)) return

            fetch(this.$store.state.apiAddr + `/v1.0/users/sys_role/set_${role}`, {
                method: "PUT",
                headers: {
                    'Authorization': `Bearer ${this.$root.GetToken()}`,
                    'Content-Type': 'text/json;charset=utf-8'
                },
                body: JSON.stringify({
                    id: id
                })
            })
            .then(response => response.json())
            .then(res => {
                if (this.$root.HandleFetchError(res)) return
                this.$root.ShowToast("Роль пользователя успешно изменена", "success")
                this._ProccessUsers()
            })
            .catch(error => {
                this.$root.Fatal()
            })

            switch (role) {
                case "worker":
                    break;
                case "listener":
                    break;
                case "student":
                    break;
            }
        },
        ChangeUser(e) {
            e.preventDefault()

            let form = e.target

            let surname = this.$refs.user_surname.value
            let name = this.$refs.user_name.value
            let lastname = this.$refs.user_lastname.value
            let birthdate = this.$refs.user_birthdate.value + "T00:00:00Z"
            let gender = this.$refs.user_gender.value
            let education_lvl = this.$refs.user_education_lvl !== null ? this.$refs.user_education_lvl.value : null
            let post = this.$refs.user_post !== null ? this.$refs.user_post.value : null
            let post_date = this.$refs.user_post_date !== null ? this.$refs.user_post_date.value + "T00:00:00Z" : null
            let ovz = this.$refs.user_ovz.checked
            let disability = this.$refs.user_disability.checked

            birthdate = birthdate == "T00:00:00Z" ? undefined : birthdate
            post_date = post_date == "T00:00:00Z" ? undefined : post_date

            let emails = this.$refs.ue.GetData()
            let phones = this.$refs.up.GetData()
            let qualifications = this.$refs.uq !== null ? this.$refs.uq.GetData() : null

            if (this.$root.HasRole(this.$store.state.adminRole)) {
                let asuID = this.$refs.user_asu_id.value
                let studID = this.$refs.user_stud_id.value
                let roles_inputs = this.$refs.user_roles.children
                let roles = []
                for (var index = 0; index < roles_inputs.length; index++) {
                    var role_input_container = roles_inputs[index]
                    var role_input = role_input_container.querySelector("input[name='role']")
                    if (role_input.checked) {
                        roles.push(role_input.value)
                    }
                }

                let generalInfo = {}
                generalInfo["id"] = this.currentUser.ID
                generalInfo["asu_id"] = Number(asuID)
                if (this.currentUser.Role == 'student') generalInfo["asu_stud_id"] = Number(studID)
                generalInfo["role"] = roles

                fetch(this.$store.state.apiAddr + "/v1.0/users/", {
                    method: "PUT",
                    headers: {
                        'Authorization': `Bearer ${this.$root.GetToken()}`,
                        'Content-Type': 'text/json;charset=utf-8'
                    },
                    body: JSON.stringify(generalInfo)
                })
                .then(response => response.json())
                .then(res => {
                    if (this.$root.HandleFetchError(res)) return
                    this.$root.ShowToast("Основные данные пользователя успешно изменены", "success")
                    this._ProccessUsers()
                })
                .catch(error => {
                    this.$root.Fatal()
                })
            }

            if (this.currentUser.Role == 'listener') {
                let study_place = this.$refs.user_study_place.value
                let work_place = this.$refs.user_work_place.value

                fetch(this.$store.state.aeApiAddr + "/v1.0/listeners/", {
                    method: "PUT",
                    headers: {
                        'Authorization': `Bearer ${this.$root.GetToken()}`,
                        'Content-Type': 'text/json;charset=utf-8'
                    },
                    body: JSON.stringify({
                        id: this.currentUser.ID,
                        name: name,
                        surname: surname,
                        middle_name: lastname,
                        date_of_birth: birthdate,
                        gender: gender,
                        level_of_education: education_lvl,
                        post: {
                            title: post,
                            date_of_taking_office: post_date
                        },
                        place_of_work: work_place,
                        place_of_study: study_place,
                        ovz: ovz,
                        disability: disability,
                        emails: emails,
                        number_phones: phones,
                        qualifications: qualifications
                    })
                })
                .then(response => response.json())
                .then(res => {
                    if (this.$root.HandleFetchError(res)) return
                    this.$root.ShowToast("Данные пользователя успешно изменены", "success")
                    this._ProccessUsers()
                })
                .catch(error => {
                    this.$root.Fatal()
                })
            }

            if (this.currentUser.Role == 'student') {
                fetch(this.$store.state.apiAddr + "/v1.0/students/", {
                    method: "PUT",
                    headers: {
                        'Authorization': `Bearer ${this.$root.GetToken()}`,
                        'Content-Type': 'text/json;charset=utf-8'
                    },
                    body: JSON.stringify({
                        id: this.currentUser.ID,
                        name: name,
                        surname: surname,
                        middle_name: lastname,
                        date_of_birth: birthdate,
                        gender: gender,
                        ovz: ovz,
                        disability: disability,
                        emails: emails,
                        number_phones: phones,
                    })
                })
                .then(response => response.json())
                .then(res => {
                    if (this.$root.HandleFetchError(res)) return
                    this.$root.ShowToast("Данные пользователя успешно изменены", "success")
                    this._ProccessUsers()
                })
                .catch(error => {
                    this.$root.Fatal()
                })
            }

            if (this.currentUser.Role == 'worker') {
                let work_exp = Number(this.$refs.user_work_exp.value)
                let education_exp = Number(this.$refs.user_education_exp.value)

                let degrees = []
                let degrees_inputs = this.$refs.ud.GetData()

                for (var i in degrees_inputs) {
                    var input_container = degrees_inputs[i]
                    var input = input_container.split(" ")

                    var date = this.$root.FormatInputDate(input.pop())

                    degrees.push({
                        "title": input.join(),
                        "date_of_assignment": date + "T00:00:00Z"
                    })
                }

                let establishments = this.$refs.uest.GetData()

                fetch(this.$store.state.apiAddr + "/v1.0/workers/", {
                    method: "PUT",
                    headers: {
                        'Authorization': `Bearer ${this.$root.GetToken()}`,
                        'Content-Type': 'text/json;charset=utf-8'
                    },
                    body: JSON.stringify({
                        id: this.currentUser.ID,
                        name: name,
                        surname: surname,
                        middle_name: lastname,
                        date_of_birth: birthdate,
                        gender: gender,
                        level_of_education: education_lvl,
                        post: {
                            title: post,
                            date_of_taking_office: post_date
                        },
                        general_experience: work_exp,
                        experience_of_teaching_work: education_exp,
                        ovz: ovz,
                        disability: disability,
                        emails: emails,
                        number_phones: phones,
                        qualifications: qualifications,
                        academic_degrees: degrees,
                        establishments: establishments
                    })
                })
                .then(response => response.json())
                .then(res => {
                    if (this.$root.HandleFetchError(res)) return
                    this.$root.ShowToast("Данные пользователя успешно изменены", "success")
                    this._ProccessUsers()
                })
                .catch(error => {
                    this.$root.Fatal()
                })
            }
        },
        DeleteUser(id) {
            fetch(this.$store.state.apiAddr + "/v1.0/users/", {
                method: "DELETE",
                headers: {
                    'Authorization': `Bearer ${this.$root.GetToken()}`,
                    'Content-Type': 'text/json;charset=utf-8'
                },
                body: JSON.stringify({ id: id })
            })
            .then(response => response.json())
            .then(res => {
                if (this.$root.HandleFetchError(res)) return
                this.$root.ShowToast("Пользователь успешно удалён", "success")
                this._ProccessUsers()
            })
            .catch(error => {
                this.$root.Fatal()
            })
        },
        async DownloadUserList() {
            try {
                var res = await fetch(this.$store.state.filesApiAddr + `/v1.0/ae/reports/users/by_params?search=${this.search_param}&gender=${this.gender_param}&role=${this.role_param}&ovz=${this.ovz_param}&disability=${this.disability_param}&alphabetical=true`, {
                    method: "POST",
                    headers: {
                        'Authorization': `Bearer ${this.$root.GetToken()}`,
                    },
                })
                .catch(error=> {
                    this.$root.ShowToast("Не удалось выгрузить список пользователей", "error")
                })

                var result = await res.blob()

                var a = document.createElement("a")
                a.setAttribute("href", URL.createObjectURL(result))
                a.setAttribute("download", res.headers.get('Content-Disposition').split('filename=')[1].split('"')[1])
                document.body.appendChild(a)
                a.click()
                URL.revokeObjectURL(a.href)
                a.remove()
            } catch (e) {
                this.$root.ShowToast("Не удалось выгрузить список пользователей", "error")
            }
            
        },
        async LoadProgramFile() {
            let fileInput = document.createElement("input")
            fileInput.type = "file"
            fileInput.style = "display: none;"

            fileInput.onchange = (e) => {
                var files = e.target.files

                let data = new FormData()

                data.append("file", files[0])

                data.append("user_id", this.currentUser.ID)
                data.append("program_id", this.currentUser.Programs[this.currentProgram].ID)

                fetch(this.$store.state.filesApiAddr + "/v1.0/ae/programs/users/files/", {
                    method: "POST",
                    headers: {
                        'Authorization': `Bearer ${this.$root.GetToken()}`,
                    },
                    body: data
                })
                .then(response => response.json())
                .then(res => {
                    if (this.$root.HandleFetchError(res)) return
                    this.$root.ShowToast("Файл программы успешно добавлен", "success")
                    this._ProccessUsers()
                    this.$root.HideModal("#SeeProgram")
                })
                .catch(error => {
                    this.$root.Fatal()
                })

                fileInput.remove()
            }

            fileInput.click()
        },
        DeleteProgramFile(userID, programmID, fileName) {
            fetch(this.$store.state.filesApiAddr + "/v1.0/ae/programs/users/files/", {
                method: "DELETE",
                headers: {
                    'Authorization': `Bearer ${this.$root.GetToken()}`,
                    'Content-Type': 'text/json;charset=utf-8'
                },
                body: JSON.stringify({
                    user_id: userID,
                    program_id: programmID,
                    file_name: fileName
                })
            })
            .then(response => response.json())
            .then(res => {
                if (this.$root.HandleFetchError(res)) return
                this.$root.ShowToast("Файл программы успешно удалён", "success")
                this._ProccessUsers()
                this.$root.HideModal("#SeeProgram")
            })
            .catch(error => {
                this.$root.Fatal()
            })
        },
        async DownloadProgramFile(userID, programmID, fileName) {
            try {
                var res = await fetch(this.$store.state.filesApiAddr + `/v1.0/ae/programs/users/files/${userID}/${programmID}/${fileName}`, {
                    method: "GET",
                    headers: {
                        'Authorization': `Bearer ${this.$root.GetToken()}`,
                    },
                })
                .catch(error=> {
                    this.$root.ShowToast("Не удалось скачать файл", "error")
                })

                var result = await res.blob()

                var a = document.createElement("a")
                a.setAttribute("href", URL.createObjectURL(result))
                a.setAttribute("download", fileName)
                document.body.appendChild(a)
                a.click()
                URL.revokeObjectURL(a.href)
                a.remove()
            } catch (e) {
                this.$root.ShowToast("Не удалось скачать файл", "error")
            }
        }
    },
    async mounted() {
        if (this.$root.fatal) return
        this.SetTitle()
        this.$root.StartLoading()
        this.$root.UpdateToken()
        this.$root.GetRoles().then(async ()=>{
            if (!(this.$root.HasRole(this.$store.state.adminRole) || this.$root.HasRole(this.$store.state.methodistRole))) {
                this.$root.ShowToast("У вас нет прав на посещение данного раздела", "error", 8000)
                this.$router.push({name: 'Home'})
                return
            }
            if (this.$root.HasRole(this.$store.state.adminRole)) {
                this._ProccessRoles()
            }

            await this._ProccessUsers()

            this.$root.EndLoading()
        })  
    }
}
</script>